<template>
  <div v-if="data" class="fineprint">
    <p v-for="(paragraph, key) in [].concat(data.body)" :key="key" v-html="paragraph"></p>
    <ul>
      <li v-for="(listItem, key) in data.list" :key="key" v-html="listItem"></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Fineprint',
  props: {
    'data': {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// BlockFineprint.vue?0d9df39a